module.exports = __webpack_public_path__ + "media/ceshi.43bf90a4.mp3";